import { render, staticRenderFns } from "./program-category.vue?vue&type=template&id=7d7b9dac&"
import script from "./program-category.vue?vue&type=script&lang=js&"
export * from "./program-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports